export default `
§ achievements.commitsAfter1500.title: Сова
§ achievements.commitsAfter1500.description: 70% коммитов после 15:00
§ achievements.commitsBefore1500.title: Ранняя пташка
§ achievements.commitsBefore1500.description: 70% коммитов до обеда
§ achievements.workEveryTime.title: Раб божий
§ achievements.workEveryTime.description: есть коммит на каждый час суток
§ achievements.workNotWork.title: Стрельба холостыми
§ achievements.workNotWork.description: коммиты есть, а закрытых задач нет
§ achievements.userNotWork.title: Залётный
§ achievements.userNotWork.description: это не его основной проект
§ achievements.userIsDied.title: Мёртвая душа
§ achievements.userIsDied.description: работал, но уволился
§ achievements.lessTasks.title: Зашел и вышел
§ achievements.lessTasks.description: меньше всего закрытых задач
§ achievements.moreTasks.title: Батя грит малаца
§ achievements.moreTasks.description: больше всего закрытых задач
§ achievements.everyMessageLong.title: Мастер красноречия
§ achievements.everyMessageLong.description: стабильно самые длинные подписи коммитов
§ achievements.everyMessageShort.title: Болтун находка для шпиона
§ achievements.everyMessageShort.description: стабильно, самые короткие подписи коммитов
§ achievements.shortestName.title: Размер не главное
§ achievements.shortestName.description: самое короткое имя
§ achievements.longestName.title: Азим Азиз Иль Ам Кадир Имран II
§ achievements.longestName.description: самое длинное имя
§ achievements.moreCommits.title: Мастер бекапов
§ achievements.moreCommits.description: больше всего коммитов
§ achievements.lessCommits.title: Редко но метко
§ achievements.lessCommits.description: меньше всего коммитов
§ achievements.oneCommitOneTask.title: Точно в цель
§ achievements.oneCommitOneTask.description: в среднем один коммит на задачу
§ achievements.moreLazyDays.title: Мысленно я с вами
§ achievements.moreLazyDays.description: больше всего дней без коммитов
§ achievements.lessLazyDays.title: Папа Карло
§ achievements.lessLazyDays.description: меньше всего дней без коммитов
§ achievements.zeroLazyDays.title: Ни единого разрыва
§ achievements.zeroLazyDays.description: ни одного дня без коммитов
§ achievements.moreWorkDays.title: Ценный работник
§ achievements.moreWorkDays.description: больше всего рабочих дней
§ achievements.moreScopes.title: Стартапер
§ achievements.moreScopes.description: сделал больше всего фичей
§ achievements.lessScopes.title: Щегол
§ achievements.lessScopes.description: сделал меньше всего фичей
§ achievements.moreDaysForTask.title: Улитка на склоне
§ achievements.moreDaysForTask.description: работа по задачам идёт медленнее чем у остальных
§ achievements.more2DaysForTask.title: Cо слоу
§ achievements.more2DaysForTask.description: больше двух дней на задачу
§ achievements.more3YearsInProject.title: Старожил
§ achievements.more3YearsInProject.description: больше трех лет на проекте
§ achievements.lessDaysInProject.title: А это кто?
§ achievements.lessDaysInProject.description: меньше всего дней на проекте
§ achievements.lessDaysForTask.title: Скорострел
§ achievements.lessDaysForTask.description: одна задача занимает меньше дня
§ achievements.adam.title: Адам
§ achievements.adam.description: первый стабильный сотрудник на проекте
§ achievements.more90DaysInProject.title: Добро пожаловать
§ achievements.more90DaysInProject.description: не уволили на испытательном
§ achievements.more365DaysInProject.title: Годовасик
§ achievements.more365DaysInProject.description: отработал год на проекте
§ achievements.more666DaysInProject.title: Чёрт
§ achievements.more666DaysInProject.description: отработал 666 дней на проекте
§ achievements.more777DaysInProject.title: Азино 3 топора
§ achievements.more777DaysInProject.description: отработал 777 дней на проекте
§ achievements.moreDaysInProject.title: Часть команды, часть корабля
§ achievements.moreDaysInProject.description: больше всего дней на проекте
§ achievements.moreRefactoring.title: Выпускающий редактор
§ achievements.moreRefactoring.description: сделал больше всех меток «рефакторинг»
§ achievements.longestMessage.title: "Языком болтать" не мешки ворочать
§ achievements.longestMessage.description: самая длинная подпись коммита за все время
§ achievements.moreTasksInDay.title: Спиди-гонщик
§ achievements.moreTasksInDay.description: рекорд по количеству закрытых задач в день
§ achievements.hasCommitFrom0to7.title: Ночной дозор
§ achievements.hasCommitFrom0to7.description: есть коммит на каждый час ночи
§ achievements.noCommitOnDay.title: Технический перерыв
§ achievements.noCommitOnDay.description: есть определенный час и день в рабочее время в который никогда не комитит
§ achievements.hasCommitEveryTime.title: Умер на работе
§ achievements.hasCommitEveryTime.description: есть коммит на час каждого дня (включая выходные)
§ achievements.commitsAfter1800.title: Делу время
§ achievements.commitsAfter1800.description: нет ни одного коммита после 18:00
§ achievements.moreFix.title: Bug hunter
§ achievements.moreFix.description: больше всего закрытых багов
§ achievements.lessWorkDays.title: Дальше без меня
§ achievements.lessWorkDays.description: меньше всего рабочих дней
§ achievements.moreCreateCode.title: Созидатель
§ achievements.moreCreateCode.description: склонен больше остальных добавлять код
§ achievements.moreRemoveCode.title: Разрушитель
§ achievements.moreRemoveCode.description: склонен больше остальных удалять код
§ achievements.moreChangeCode.title: Реформатор
§ achievements.moreChangeCode.description: склонен больше остальных изменять код
§ achievements.moreStyle.title: Полиция моды
§ achievements.moreStyle.description: склонен больше остальных изменять CSS
§ achievements.moreOnHoliday.title: Нет жизни
§ achievements.moreOnHoliday.description: относительно много коммитов в нерабочее время
§ achievements.morePRMerge.title: Таможня даёт добро
§ achievements.morePRMerge.description: чаще остальных нажимает кнопку «Влить» для PR
§ achievements.longWaitPR.title: Завтра точно вольём
§ achievements.longWaitPR.description: создал PR, который больше месяца провисел на ревью
§ achievements.moreLongWaitPR.title: Давным давно, в далёкой галактике
§ achievements.moreLongWaitPR.description: создал PR, который максимально долго провисел на ревью
§ achievements.oneExtension.title: Один в поле воин
§ achievements.oneExtension.description: только он работает с файлами определенного расширения
§ achievements.fileRush.title: Зерг Раш
§ achievements.fileRush.description: создал больше всех файлов в проекте
§ achievements.moreLintHint.title: Грамар-наци
§ achievements.moreLintHint.description: больше всех создал или изменил в правилах авто-проверки кода
§ achievements.moreReadMe.title: Летописец
§ achievements.moreReadMe.description: больше всех создал или изменил файлов MD
§ achievements.moreDevOps.title: DevOps
§ achievements.moreDevOps.description: больше всех создал или изменил файлов для CI/CD
§ achievements.moreTests.title: Тестировщик
§ achievements.moreTests.description: больше всех создал или изменил файлов для тестирования
§ achievements.allRelease.title: Фулл хаус
§ achievements.allRelease.description: есть релиз, собранный только из его задач
§ achievements.firstCommit.title: Кто первый, того и тапки
§ achievements.firstCommit.description: первый коммит на проекте
§ achievements.lastCommit.title: Я закончил
§ achievements.lastCommit.description: последний коммит на проекте
§ achievements.firstLastCommit.title: От начала и до конца
§ achievements.firstLastCommit.description: первый и последний коммит на проекте
§ achievements.longFilePath.title: Закрома родины
§ achievements.longFilePath.description: первый создал файл с самым глубоким вложением
§ achievements.longFileName.title: Размер имеет значение
§ achievements.longFileName.description: создал файл с самым длинным именемм
§ achievements.workOnWeekends.title: Работа не walk
§ achievements.workOnWeekends.description: хоть раз работал на выходных
§ achievements.removeCreateFile.title: Откопал стюардессу
§ achievements.removeCreateFile.description: востановил удаленный файл
§ achievements.renameFile.title: Астана Нур-Султан Астана
§ achievements.renameFile.description: переименовывал туда-сюда файл
§ achievements.longTask.title: Вроде изян
§ achievements.longTask.description: работал над задачей больше трех месяцев
§ achievements.haveNotEmail.title: Почтальон Печкин 
§ achievements.haveNotEmail.description: не заполнил поле e-mail в git config
§ achievements.moreAddedFolders.title: Директор 
§ achievements.moreAddedFolders.description: создал больше всех дирректорий
§ achievements.horoscope1.title: Ретроградный Меркурий в Козероге
§ achievements.horoscope2.title: Ретроградный Меркурий в Водолее
§ achievements.horoscope3.title: Ретроградный Меркурий в Рыбе
§ achievements.horoscope4.title: Ретроградный Меркурий в Овне
§ achievements.horoscope5.title: Ретроградный Меркурий в Тельце
§ achievements.horoscope6.title: Ретроградный Меркурий в Близнеце
§ achievements.horoscope7.title: Ретроградный Меркурий в Раке
§ achievements.horoscope8.title: Ретроградный Меркурий в Льве
§ achievements.horoscope9.title: Ретроградный Меркурий в Деве
§ achievements.horoscope10.title: Ретроградный Меркурий в Весах
§ achievements.horoscope11.title: Ретроградный Меркурий в Скорпионе
§ achievements.horoscope12.title: Ретроградный Меркурий в Стрельце
§ achievements.horoscope1.description: по месяцу первого коммита
§ achievements.horoscope2.description: по месяцу первого коммита
§ achievements.horoscope3.description: по месяцу первого коммита
§ achievements.horoscope4.description: по месяцу первого коммита
§ achievements.horoscope5.description: по месяцу первого коммита
§ achievements.horoscope6.description: по месяцу первого коммита
§ achievements.horoscope7.description: по месяцу первого коммита
§ achievements.horoscope8.description: по месяцу первого коммита
§ achievements.horoscope9.description: по месяцу первого коммита
§ achievements.horoscope10.description: по месяцу первого коммита
§ achievements.horoscope11.description: по месяцу первого коммита
§ achievements.horoscope12.description: по месяцу первого коммита
§ achievements.111.description: test
`;
